import { gql } from "@apollo/client";

export const LIKE_BRAND = gql`
  mutation LikeBrand($brandId: Int!) {
    likeBrand(brandId: $brandId) {
      id
      userId
      brandId
      createdAt
      brand {
        id
        name
      }
    }
  }
`;

export const CANCEL_BRAND_LIKE = gql`
  mutation CancelBrandLike($brandId: Int!) {
    cancelBrandLike(brandId: $brandId) {
      id
      userId
      brandId
      createdAt
      brand {
        id
        name
      }
    }
  }
`;

export const GET_USER_BRAND_LIKES = gql`
  query GetUserBrandLikes {
    getUserBrandLikes {
      id
      userId
      brandId
      createdAt
      brand {
        id
        name
        lat
        lng
        roadAddr
        instagramUrl
        naverPlaceUrl
      }
    }
  }
`;
